import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Breadcrumbs from "../../globals/core/Breadcrumbs/Breadcrumb";
import { CurriculaService } from "../../globals/services/curricula.service";
import { ReactComponent as CurriculaIcon } from "../../assets/images/curricula.svg";
import { Input, Label, Table } from "reactstrap";
import { environment } from "../../environment";
import { Link } from "react-router-dom";

export const Curricula = () => {
  const [curriculaList, setCurriculaList] = useState([]);
  const [curriculaListSize, setCurriculaListSize] = useState(0);
  const [defaultItems, setDefaultItems] = useState([]);
  const [filterTitle, setFilterTitle] = useState();
  const [filterTemplate, setFilterTemplate] = useState();
  const [loading, setLoading] = useState(true);

  let history = useHistory();

  useEffect(() => {
    setLoading(true);
    const curriculaService = CurriculaService();
    curriculaService.filterCurriculaList("All").then((res) => {
      setCurriculaList(res.data);
      setCurriculaListSize(res.data.length);
      setDefaultItems(res.data);
      setLoading(false);
    });
  }, []);

  const handleEdit = (e, item) => {
    e.preventDefault();
    history.push(`/curriculaDetail/${item._id}`, { item });
  };

  const filterByName = async (e, key, value) => {
    if (value.length > 2) {
      setLoading(true);
      if (key === "title") {
        const curriculaService = CurriculaService();
        const res = await curriculaService.filterCurriculaList(value);
        setCurriculaList(res.data);
        setCurriculaListSize(res.data.length);
      } else if (key === "template") {
        const _items = curriculaList.filter((i) => i?.entityTemplatesData?.[0]?.title.toLowerCase().includes(value.toLowerCase()));
        setCurriculaList(_items);
        setCurriculaListSize(_items.length);
        setFilterTitle(null);
      }
      setLoading(false);
    } else if (value.length === 0) {
      setCurriculaList(defaultItems);
      setCurriculaListSize(defaultItems.length);
      setFilterTemplate(null);
      setFilterTitle(null);
    }
  };

  return (
    <div className="content">
      <div className="page-content">
        <div className="container-fluid">
          <div className="mb-3">
            <Breadcrumbs title="MAIN" breadcrumbItem="Curricula list" />
            <div>{curriculaListSize} items</div>
          </div>

          <div className="row mb-2">
            <div className="col-9 d-flex">
              <div className="form-group col-md-3 mr-2">
                <h5 className="mt-4">
                  <Label htmlFor="_name">Title</Label>
                </h5>
                <Input
                  id="searchName"
                  name="searchName"
                  placeholder="Search by curriculum title..."
                  type="text"
                  value={filterTitle}
                  onChange={(e) => filterByName(e, "title", e.target.value)}
                />
              </div>

              <div className="form-group col-md-3 mr-2">
                <h5 className="mt-4">
                  <Label htmlFor="_name">Template</Label>
                </h5>
                <Input
                  id="searchTemplate"
                  name="searchTemplate"
                  placeholder="filter view by template..."
                  type="text"
                  value={filterTemplate}
                  onChange={(e) => filterByName(e, "template", e.target.value)}
                />
              </div>
            </div>
          </div>

          {loading ? (
            <div className="loaderContainer d-flex flex-column">
              <div className="loader"></div>
              <div className="loaderText">Loading Curricula</div>
            </div>
          ) : (
            <div className="row justify-content-around">
              <div className="col-8"></div>
              <div className="col-12">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>Status</th>
                      <th>Template</th>
                      <th>Team</th>
                      <th>Participants</th>
                      <th>Edit</th>
                      <th>Salesforce</th>
                    </tr>
                  </thead>
                  <tbody>
                    {curriculaList &&
                      curriculaList.map((item, index) => {
                        const numberOfParticipants = (item?.entityParticipants || []).filter((participant) => participant.Status__c !== "Canceled").length;
                        const numberOfTeamMember = (item?.entityTeams || []).length;

                        return (
                          <tr key={item.sfSeminarId}>
                            <td onClick={(e) => handleEdit(e, item)}>
                              <div className="d-flex align-items-center">
                                <CurriculaIcon />
                                <div className="flex-grow-1 w-0">{item.entityTitle}</div>
                              </div>
                            </td>
                            <td>{item.entityStatus}</td>
                            <td>{item.entityTemplatesData[0]?.title}</td>
                            <td className="text-center">{numberOfTeamMember}</td>
                            <td className="text-center">{numberOfParticipants}</td>
                            <td>
                              <button className="listCTA" onClick={(e) => handleEdit(e, item)}>
                                Edit
                              </button>
                            </td>
                            <td>
                              <Link className="listCTALink" to={{ pathname: environment.sfdcUrl + item.sfSeminarId }} target="_blank">
                                Go To SFDC
                              </Link>
                            </td>
                          </tr>
                        );
                      }, [])}
                  </tbody>
                </Table>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
